import { motion } from "framer-motion";

interface Props {
    children: React.ReactNode;
}

let props = {
    initial: "hidden",
    animate: "visible",
    variants:{
        visible: { opacity: 1 },
        hidden: { opacity: 0 }
    },
    transition: { ease: "easeIn", duration: 0.25 },
    exit: {
      opacity: 0,

      transition: { ease: "easeOut", duration: 0.25 }
    }
}


const Index = ({ children }: Props) => {
    return <motion.div  {...props}>
                {   children}
            </motion.div>
};

export default Index;
